import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kinnita

  <span style="color:#85c1dc;">**FI:**</span>
  Vahvista

  <span style="color:#85c1dc;">**RU:**</span>
  Подтвердить
*/
/* @__NO_SIDE_EFFECTS__ */
const m1065 = msg(
  mf`Kinnita`,
  mf`Vahvista`,
  mf`Подтвердить`,
)

export { m1065 as 'w.basket.summary.voucher_confirm' }